export default "__VITE_ASSET__D97waqL4__"